<template>
  <div class="nebula-header-wrapper">
    <!-- 스켈레톤 UI (로딩 중에 표시) -->
    <div v-if="loading" class="nebula-header-skeleton">
      <!-- 프로모션 배너 스켈레톤 -->
      <div class="nebula-skeleton-promotion-banner" :class="{'mobile-hidden': isMobile}">
        <div class="nebula-container">
          <div class="nebula-skeleton-promotion-content"></div>
        </div>
      </div>

      <!-- 로고 및 유틸리티 스켈레톤 -->
      <div class="nebula-skeleton-top-header">
        <div class="nebula-container">
          <div class="nebula-skeleton-header-content">
            <div class="nebula-skeleton-header-left" :class="{'mobile-hidden': isMobile}">
              <div class="nebula-skeleton-logo"></div>
              <div class="nebula-skeleton-logo"></div>
              <div class="nebula-skeleton-favorite"></div>
            </div>
            <div class="nebula-skeleton-header-right">
              <div class="nebula-skeleton-utility-icons">
                <div class="nebula-skeleton-icon"></div>
                <div class="nebula-skeleton-icon"></div>
                <div class="nebula-skeleton-icon"></div>
              </div>
              <div class="nebula-skeleton-auth-buttons">
                <div class="nebula-skeleton-btn"></div>
                <div class="nebula-skeleton-btn"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 검색 및 메인 로고 스켈레톤 - 모바일 메뉴 버튼 스켈레톤 추가 -->
      <div class="nebula-skeleton-main-header">
        <div class="nebula-container">
          <!-- 모바일 메뉴 버튼 스켈레톤 추가 -->
          <div class="mobile-skeleton-menu-btn" v-if="isMobile"></div>

          <div class="nebula-skeleton-main-header-content">
            <div class="nebula-skeleton-main-logo"></div>
            <div class="nebula-skeleton-search-bar" :class="{'mobile-hidden': isMobile}"></div>
            <div class="nebula-skeleton-kakao-promo" :class="{'mobile-hidden': isMobile}"></div>
          </div>

          <!-- 모바일 검색 버튼 스켈레톤 추가 -->
          <div class="mobile-skeleton-search-btn" v-if="isMobile"></div>
        </div>
      </div>

      <!-- 메인 네비게이션 스켈레톤 -->
<!--      <div class="nebula-skeleton-main-nav" :class="{'mobile-hidden': isMobile}">-->
<!--        <div class="nebula-container">-->
<!--          <div class="nebula-skeleton-nav-content">-->
<!--            <div class="nebula-skeleton-primary-nav">-->
<!--              <div v-for="i in 5" :key="`primary-nav-${i}`" class="nebula-skeleton-nav-item"></div>-->
<!--            </div>-->
<!--            <div class="nebula-skeleton-secondary-nav">-->
<!--              <div v-for="i in 4" :key="`secondary-nav-${i}`" class="nebula-skeleton-nav-item-small"></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>

    <!-- 실제 헤더 컨텐츠 (로딩 완료 후 표시) -->
    <div v-else>
      <!-- 상단 프로모션 배너 (모바일에서는 숨김) -->
      <div class="nebula-promotion-banner" v-if="showPromoBanner && !isMobile">
        <div class="nebula-container">
          <div class="nebula-promotion-content">
<!--            <img src="@/assets/user/img/noti_icon2.png" alt="로고">-->
            <span class="nebula-promotion-text">"합리적인 가격 제안으로 빠르게 응답드립니다"</span>
<!--            <img src="@/assets/user/img/noti_icon.png" alt="로고">-->
            <button class="nebula-close-btn" @click="closePromoBanner">
              <span>1일간 닫기</span>
              <i class="bi bi-x"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- 로고 및 유틸리티 영역 -->
      <div class="nebula-top-header">
        <div class="nebula-container">
          <div class="nebula-header-content">
            <!-- 왼쪽 로고 영역 (PC) -->
            <div class="nebula-header-left" v-if="!isMobile">
              <button class="nebula-favorite-btn" @click="addToFavorites">
                <i class="bi bi-star-fill"></i>
                <span>마이툴 즐겨찾기</span>
              </button>
              <a href="/mypage/quote-requests" class="nebula-header-link">
                <i class="bi bi-plus-circle"></i>
                <span>상품등록요청</span>
              </a>
            </div>

            <!-- 왼쪽 바로가기 (모바일) -->
            <div class="nebula-header-left-mobile" v-if="isMobile">
              <a href="/mypage/quote-requests" class="mobile-header-link">
                <i class="bi bi-plus-circle"></i>
                <span>상품등록요청</span>
              </a>
              <a href="/quote-order" class="mobile-header-link">
                <i class="bi bi-file-earmark-text"></i>
                <span>견적서주문</span>
              </a>
            </div>

            <!-- 오른쪽 유틸리티 영역 -->
            <div class="nebula-header-right">
              <div class="nebula-utility-icons">
                <button class="nebula-icon-btn" onclick="location.href='/mypage'">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="M240.92-268.31q51-37.84 111.12-59.77Q412.15-350 480-350t127.96 21.92q60.12 21.93 111.12 59.77 37.3-41 59.11-94.92Q800-417.15 800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 62.85 21.81 116.77 21.81 53.92 59.11 94.92ZM480.01-450q-54.78 0-92.39-37.6Q350-525.21 350-579.99t37.6-92.39Q425.21-710 479.99-710t92.39 37.6Q610-634.79 610-580.01t-37.6 92.39Q534.79-450 480.01-450ZM480-100q-79.15 0-148.5-29.77t-120.65-81.08q-51.31-51.3-81.08-120.65Q100-400.85 100-480t29.77-148.5q29.77-69.35 81.08-120.65 51.3-51.31 120.65-81.08Q400.85-860 480-860t148.5 29.77q69.35 29.77 120.65 81.08 51.31 51.3 81.08 120.65Q860-559.15 860-480t-29.77 148.5q-29.77 69.35-81.08 120.65-51.3 51.31-120.65 81.08Q559.15-100 480-100Zm0-60q54.15 0 104.42-17.42 50.27-17.43 89.27-48.73-39-30.16-88.11-47Q536.46-290 480-290t-105.77 16.65q-49.31 16.66-87.92 47.2 39 31.3 89.27 48.73Q425.85-160 480-160Zm0-350q29.85 0 49.92-20.08Q550-550.15 550-580t-20.08-49.92Q509.85-650 480-650t-49.92 20.08Q410-609.85 410-580t20.08 49.92Q450.15-510 480-510Zm0-70Zm0 355Z"/></svg>
                </button>
                <button class="nebula-icon-btn nebula-icon-notification" onclick="location.href='/cart'">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="M286.15-97.69q-29.15 0-49.57-20.43-20.42-20.42-20.42-49.57 0-29.16 20.42-49.58 20.42-20.42 49.57-20.42 29.16 0 49.58 20.42 20.42 20.42 20.42 49.58 0 29.15-20.42 49.57-20.42 20.43-49.58 20.43Zm387.7 0q-29.16 0-49.58-20.43-20.42-20.42-20.42-49.57 0-29.16 20.42-49.58 20.42-20.42 49.58-20.42 29.15 0 49.57 20.42t20.42 49.58q0 29.15-20.42 49.57Q703-97.69 673.85-97.69ZM240.61-730 342-517.69h272.69q3.46 0 6.16-1.73 2.69-1.73 4.61-4.81l107.31-195q2.31-4.23.38-7.5-1.92-3.27-6.54-3.27h-486Zm-28.76-60h555.38q24.54 0 37.11 20.89 12.58 20.88 1.2 42.65L677.38-494.31q-9.84 17.31-26.03 26.96-16.2 9.66-35.5 9.66H324l-46.31 84.61q-3.08 4.62-.19 10 2.88 5.39 8.65 5.39h427.7q12.76 0 21.38 8.61 8.61 8.62 8.61 21.39 0 12.77-8.61 21.38-8.62 8.62-21.38 8.62h-427.7q-40 0-60.11-34.5-20.12-34.5-1.42-68.89l57.07-102.61L136.16-810H90q-12.77 0-21.38-8.62Q60-827.23 60-840t8.62-21.38Q77.23-870 90-870h61.15q10.24 0 19.08 5.42 8.85 5.43 13.46 15.27L211.85-790ZM342-517.69h280-280Z"/></svg>
                  <span class="nebula-badge">{{ cartItemCount }}</span>
                </button>
                <button class="nebula-icon-btn nebula-icon-cart" onclick="location.href='/mypage/notification-settings'">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="M210-204.62q-12.75 0-21.37-8.62-8.63-8.63-8.63-21.39 0-12.75 8.63-21.37 8.62-8.61 21.37-8.61h42.31v-298.47q0-80.69 49.81-142.69 49.8-62 127.88-79.31V-810q0-20.83 14.57-35.42Q459.14-860 479.95-860q20.82 0 35.43 14.58Q530-830.83 530-810v24.92q78.08 17.31 127.88 79.31 49.81 62 49.81 142.69v298.47H750q12.75 0 21.37 8.62 8.63 8.63 8.63 21.39 0 12.75-8.63 21.37-8.62 8.61-21.37 8.61H210Zm270-293.07Zm-.07 405.38q-29.85 0-51.04-21.24-21.2-21.24-21.2-51.07h144.62q0 29.93-21.26 51.12-21.26 21.19-51.12 21.19Zm-167.62-172.3h335.38v-298.47q0-69.46-49.11-118.57-49.12-49.12-118.58-49.12-69.46 0-118.58 49.12-49.11 49.11-49.11 118.57v298.47Z"/></svg>
                  <span class="nebula-badge">0</span>
                </button>

                <!-- 로그인/로그아웃 버튼 -->
                <div v-if="isLoggedIn" class="auth-buttons">
                  <span class="user-name">{{ userName }}</span>
                  <button class="logout-btn" @click="handleLogout">로그아웃</button>
                </div>
                <div v-else class="auth-buttons">
                  <router-link to="/login" class="login-btn">로그인</router-link>
                  <router-link to="/signup" class="signup-btn">회원가입</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 검색 및 메인 로고 영역 -->
      <div class="nebula-main-header">
        <div class="nebula-container">
          <!-- 모바일 메뉴 버튼 -->
          <button class="mobile-menu-btn" @click="toggleMobileMenu" v-if="isMobile">
            <i class="bi bi-list"></i>
          </button>

          <div class="nebula-main-header-content">
            <!-- 메인 로고 -->
            <div class="nebula-main-logo">
              <a href="/home"> <img src="@/assets/images/logo.png" alt="로고"></a>
            </div>

            <!-- 검색창 (모바일에서는 숨김) -->
            <div class="nebula-search-bar" v-if="!isMobile">
              <input type="text" class="nebula-search-input"
                     placeholder="키워드 또는 제품명을 검색"
                     v-model="searchQuery"
                     @keyup.enter="searchProducts">
              <button class="nebula-search-btn" @click="searchProducts">
                <i class="bi bi-search"></i>
              </button>
            </div>

            <!-- 카카오 프로모션 (모바일에서는 숨김) -->
            <div class="nebula-promotion-slide" v-if="!isMobile">
              <div class="nebula-slide-container" :style="{ transform: `translateX(-${currentSlide * 25}%)` }">
                <!-- 슬라이드 1: 카카오 프로모션 -->
<!--                <div class="nebula-slide-item nebula-kakao-promo">-->
<!--                  <div class="nebula-kakao-icon">-->
<!--                    <i class="bi bi-chat-fill"></i>-->
<!--                  </div>-->
<!--                  <div class="nebula-kakao-text">-->
<!--                    <p class="nebula-kakao-title">10,000포인트 받아가세요~</p>-->
<!--                    <p class="nebula-kakao-subtitle">카카오채널 친구추가 이벤트</p>-->
<!--                  </div>-->
<!--                </div>-->

                <!-- 슬라이드 2: 신규 가입 혜택 -->
<!--                <div class="nebula-slide-item nebula-new-promo">-->
<!--                  <div class="nebula-promo-icon">-->
<!--                    <i class="bi bi-gift-fill"></i>-->
<!--                  </div>-->
<!--                  <div class="nebula-promo-text">-->
<!--                    <p class="nebula-promo-title">신규 가입 특별 혜택</p>-->
<!--                    <p class="nebula-promo-subtitle">회원가입 시 5,000원 쿠폰 증정</p>-->
<!--                  </div>-->
<!--                </div>-->

                <!-- 슬라이드 3: 무료 배송 -->
                <div class="nebula-slide-item nebula-shipping-promo">
                  <div class="nebula-promo-icon">
                    <i class="bi bi-truck"></i>
                  </div>
                  <div class="nebula-promo-text">
                    <p class="nebula-promo-title">30만원 이상 무료배송</p>
                    <p class="nebula-promo-subtitle">빠르고 안전한 배송서비스</p>
                  </div>
                </div>

                <!-- 슬라이드 4: 첫 구매 할인 -->
                <div class="nebula-slide-item nebula-discount-promo">
                  <div class="nebula-promo-icon">
                    <i class="bi bi-percent"></i>
                  </div>
                  <div class="nebula-promo-text">
                    <p class="nebula-promo-title">대량 구매 할인제공</p>
                    <p class="nebula-promo-subtitle">신규 회원 전용 특별 혜택</p>
                  </div>
                </div>
              </div>

              <!-- 슬라이드 네비게이션 버튼 -->
              <div class="nebula-slide-nav">
                <button class="nebula-slide-btn" @click="prevSlide">
                  <i class="bi bi-chevron-left"></i>
                </button>
                <div class="nebula-slide-indicators">
                  <span
                      v-for="(_, index) in promotionSlides"
                      :key="index"
                      :class="['nebula-slide-dot', { active: currentSlide === index }]"
                      @click="goToSlide(index)"
                  ></span>
                </div>
                <button class="nebula-slide-btn" @click="nextSlide">
                  <i class="bi bi-chevron-right"></i>
                </button>
              </div>
            </div>

            <!-- 주요 카테고리 바로가기 (모바일에서는 숨김) -->
            <div class="nebula-quick-categories" v-if="!isMobile">
              <a href="/quote-order" class="nebula-quick-category-link">
                <i class="bi bi-file-earmark-text"></i>
                <span>견적서주문</span>
              </a>
              <span class="nebula-category-divider">|</span>
              <a href="/mypage/quote-requests" class="nebula-quick-category-link">
                <i class="bi bi-plus-circle"></i>
                <span>상품등록 요청</span>
              </a>
              <span class="nebula-category-divider">|</span>
              <a href="#" class="nebula-quick-category-link" @click.prevent="openCategoryModal('category')">
                <i class="bi bi-grid"></i>
                <span>카테고리</span>
              </a>
              <span class="nebula-category-divider">|</span>
              <a href="#" class="nebula-quick-category-link" @click.prevent="openCategoryModal('brand')">
                <i class="bi bi-award"></i>
                <span>브랜드</span>
              </a>
            </div>

            <!-- 카테고리/브랜드 모달 -->
            <div class="nebula-modal" v-if="showModal" @click.self="closeModal">
              <div class="nebula-modal-content" :class="{'nebula-modal-brand': modalType === 'brand'}">
                <div class="nebula-modal-header">
                  <h3>{{ modalType === 'category' ? '카테고리' : '브랜드' }}</h3>
                  <button class="nebula-modal-close" @click="closeModal">
                    <i class="bi bi-x"></i>
                  </button>
                </div>
                <div class="nebula-modal-body">
                  <!-- 카테고리 모달 내용 수정 -->
                  <div v-if="modalType === 'category'" class="nebula-modal-category-container">
                    <!-- 좌측 카테고리 목록 (2차 카테고리) -->
                    <div class="nebula-modal-category-left">
                      <ul class="nebula-modal-category-list">
                        <li class="nebula-modal-category-item"
                            v-for="(category, index) in categories"
                            :key="index"
                            @click="selectCategory(index)"
                            :class="{'active': selectedCategoryIndex === index}">
                          <a href="#" class="nebula-modal-category-link" @click.prevent>
                            <img :src="category.icon" alt="카테고리 아이콘" class="nebula-modal-category-icon">
                            <span>{{ category.name }}</span>
                          </a>
                        </li>
                      </ul>
                    </div>

                    <!-- 우측 서브카테고리 영역 (3차, 4차 카테고리) -->
                    <div class="nebula-modal-subcategory-right">
                      <keep-alive>
                        <div class="nebula-modal-subcategory-content">
<!--                          <div class="nebula-modal-subcategory-banner">-->
<!--                            <img :src="selectedCategory.bannerImage" alt="카테고리 배너">-->
<!--                          </div>-->
                          <div class="nebula-modal-subcategory-list">
                            <div class="nebula-modal-subcategory-group"
                                 v-for="(group, groupIndex) in selectedCategory.subCategories"
                                 :key="`${selectedCategoryIndex}-${groupIndex}`">
                              <h4 class="nebula-modal-subcategory-title">{{ group.title }}</h4>
                              <ul class="nebula-modal-subcategory-items">
                                <!-- 서브카테고리 항목 클릭 시 상품 리스트로 이동 -->
                                <li v-for="(item, itemIndex) in group.items" :key="`${selectedCategoryIndex}-${groupIndex}-${itemIndex}`">
                                  <a href="#"
                                     @click.prevent="navigateToCategoryAndCloseModal('/products?category=' + encodeURIComponent(item))"
                                     class="nebula-modal-subcategory-link"
                                     :class="{'sub-category': item.startsWith('-')}">
                                    {{ item.startsWith('-') ? item.substring(1).trim() : item }}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </keep-alive>
                    </div>
                  </div>

                  <!-- 브랜드 모달 내용 -->
                  <div v-else class="nebula-modal-brand-container">
                    <!-- 사이드 알파벳/한글 인덱스 -->
                    <div class="nebula-modal-brand-index">
                      <a href="#korean" class="nebula-modal-lang-title">한글</a>
                      <div class="nebula-modal-letter-list korean">
                        <a href="#kor-ㄱ" class="nebula-modal-letter-link">ㄱ</a>
                        <a href="#kor-ㄴ" class="nebula-modal-letter-link">ㄴ</a>
                        <a href="#kor-ㄷ" class="nebula-modal-letter-link">ㄷ</a>
                        <a href="#kor-ㄹ" class="nebula-modal-letter-link">ㄹ</a>
                        <a href="#kor-ㅁ" class="nebula-modal-letter-link">ㅁ</a>
                        <a href="#kor-ㅂ" class="nebula-modal-letter-link">ㅂ</a>
                        <a href="#kor-ㅅ" class="nebula-modal-letter-link">ㅅ</a>
                        <a href="#kor-ㅇ" class="nebula-modal-letter-link">ㅇ</a>
                        <a href="#kor-ㅈ" class="nebula-modal-letter-link">ㅈ</a>
                        <a href="#kor-ㅊ" class="nebula-modal-letter-link">ㅊ</a>
                        <a href="#kor-ㅋ" class="nebula-modal-letter-link">ㅋ</a>
                        <a href="#kor-ㅌ" class="nebula-modal-letter-link">ㅌ</a>
                        <a href="#kor-ㅍ" class="nebula-modal-letter-link">ㅍ</a>
                        <a href="#kor-ㅎ" class="nebula-modal-letter-link">ㅎ</a>
                      </div>
                      <a href="#english" class="nebula-modal-lang-title">영문</a>
                      <div class="nebula-modal-letter-list english">
                        <a href="#eng-A" class="nebula-modal-letter-link">A</a>
                        <a href="#eng-B" class="nebula-modal-letter-link">B</a>
                        <a href="#eng-C" class="nebula-modal-letter-link">C</a>
                        <a href="#eng-D" class="nebula-modal-letter-link">D</a>
                        <a href="#eng-E" class="nebula-modal-letter-link">E</a>
                        <a href="#eng-F" class="nebula-modal-letter-link">F</a>
                        <a href="#eng-G" class="nebula-modal-letter-link">G</a>
                        <a href="#eng-H" class="nebula-modal-letter-link">H</a>
                        <a href="#eng-I" class="nebula-modal-letter-link">I</a>
                        <a href="#eng-J" class="nebula-modal-letter-link">J</a>
                        <a href="#eng-K" class="nebula-modal-letter-link">K</a>
                        <a href="#eng-L" class="nebula-modal-letter-link">L</a>
                        <a href="#eng-M" class="nebula-modal-letter-link">M</a>
                        <a href="#eng-N" class="nebula-modal-letter-link">N</a>
                        <a href="#eng-O" class="nebula-modal-letter-link">O</a>
                        <a href="#eng-P" class="nebula-modal-letter-link">P</a>
                        <a href="#eng-Q" class="nebula-modal-letter-link">Q</a>
                        <a href="#eng-R" class="nebula-modal-letter-link">R</a>
                        <a href="#eng-S" class="nebula-modal-letter-link">S</a>
                        <a href="#eng-T" class="nebula-modal-letter-link">T</a>
                        <a href="#eng-U" class="nebula-modal-letter-link">U</a>
                        <a href="#eng-V" class="nebula-modal-letter-link">V</a>
                        <a href="#eng-W" class="nebula-modal-letter-link">W</a>
                        <a href="#eng-X" class="nebula-modal-letter-link">X</a>
                        <a href="#eng-Y" class="nebula-modal-letter-link">Y</a>
                        <a href="#eng-Z" class="nebula-modal-letter-link">Z</a>
                      </div>
                    </div>

                    <!-- 브랜드 목록 -->
                    <div class="nebula-modal-brand-list">
                      <div id="korean" class="nebula-modal-lang-section">
                        <h2 class="nebula-modal-lang-header">한글 브랜드</h2>
                        <div v-for="group in koreanBrands" :key="'kor-' + group.letter" class="nebula-modal-brand-group">
                          <h3 :id="'kor-' + group.letter" class="nebula-modal-brand-letter">{{ group.letter }}</h3>
                          <div v-for="(brand, idx) in group.items" :key="'korbrand-' + idx" class="nebula-modal-brand-item">
                            <a href="#"
                               @click.prevent="navigateToCategoryAndCloseModal('/products?brand=' + encodeURIComponent(brand.name))"
                               class="nebula-modal-brand-link">
                              <img v-if="brand.logo" :src="brand.logo" :alt="brand.name" class="nebula-modal-brand-logo">
                              <div v-else class="nebula-modal-brand-placeholder">{{ brand.name.charAt(0) }}</div>
                              <span class="nebula-modal-brand-name">{{ brand.name }}</span>
                            </a>
                          </div>
                        </div>
                      </div>

                      <div id="english" class="nebula-modal-lang-section">
                        <h2 class="nebula-modal-lang-header">영문 브랜드</h2>
                        <div v-for="group in englishBrands" :key="'eng-' + group.letter" class="nebula-modal-brand-group">
                          <h3 :id="'eng-' + group.letter" class="nebula-modal-brand-letter">{{ group.letter }}</h3>
                          <div class="nebula-modal-brand-items">
                            <div v-for="(brand, idx) in group.items" :key="'engbrand-' + idx" class="nebula-modal-brand-item">
                              <a href="#" class="nebula-modal-brand-link">
                                <img :src="brand.logo" :alt="brand.name" class="nebula-modal-brand-logo">
                                <span class="nebula-modal-brand-name">{{ brand.name }}</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 모바일 검색 버튼 -->
            <button class="mobile-search-btn" @click="toggleMobileSearch" v-if="isMobile">
              <i class="bi bi-search"></i>
            </button>
          </div>

          <!-- 모바일 검색창 (기본적으로 숨겨져 있음) -->
          <div class="mobile-search-container" v-if="showMobileSearch && isMobile">
            <div class="mobile-search-wrapper">
              <input type="text" class="mobile-search-input"
                     placeholder="키워드 또는 제품명을 검색"
                     v-model="searchQuery"
                     @keyup.enter="searchProducts">
              <button class="mobile-search-submit" @click="searchProducts">
                <i class="bi bi-search"></i>
              </button>
              <button class="mobile-search-close" @click="toggleMobileSearch">
                <i class="bi bi-x"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 모바일 풀스크린 메뉴 -->
      <div class="mobile-fullscreen-menu" :class="{ 'active': showMobileMenu }">
        <div class="mobile-menu-header">
          <h3>카테고리</h3>
          <button class="mobile-menu-close" @click="toggleMobileMenu">
            <i class="bi bi-x"></i>
          </button>
        </div>

        <!-- 모바일 대분류/중분류 메뉴 -->
        <div class="mobile-category-container">
          <!-- 대분류 메뉴 -->
          <div class="mobile-category-main">
            <div
                v-for="(category, index) in categories"
                :key="`mobile-cat-${index}`"
                class="mobile-category-item"
                :class="{ 'active': mobileSelectedCategory === index }"
                @click="selectMobileCategory(index)">
              <img :src="category.icon" alt="카테고리 아이콘" class="mobile-category-icon">
              <span>{{ category.name }}</span>
              <i class="bi bi-chevron-right"></i>
            </div>
          </div>

          <!-- 중분류/소분류 메뉴 -->
          <div class="mobile-category-sub" v-if="categories[mobileSelectedCategory]">
            <div class="mobile-subcategory-group" v-for="(group, groupIndex) in categories[mobileSelectedCategory].subCategories" :key="groupIndex">
              <h4 class="mobile-subcategory-title">{{ group.title }}</h4>
              <div class="mobile-subcategory-items">
                <a v-for="(item, itemIndex) in group.items"
                   :key="itemIndex"
                   href="#"
                   class="mobile-subcategory-link"
                   @click.prevent="navigateToCategoryAndCloseModal('/products?category=' + encodeURIComponent(item))">
                  {{ item }}
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- 공통 메뉴 링크 -->
        <div class="mobile-menu-common-links">
          <a href="/quote-order" class="mobile-menu-common-link" @click="closeMenu">
            <i class="bi bi-file-earmark-text"></i>
            <span>견적서주문</span>
          </a>
          <a href="/mypage/quote-requests" class="mobile-menu-common-link" @click="closeMenu">
            <i class="bi bi-plus-circle"></i>
            <span>상품등록 요청</span>
          </a>
<!--          <a href="/new-products" class="mobile-menu-common-link" @click="closeMenu">-->
<!--            <img src="@/assets/user/img/free-icon-syringe-1021573.png">-->
<!--            <span>신상품</span>-->
<!--          </a>-->
<!--          <a href="/promotions" class="mobile-menu-common-link" @click="closeMenu">-->
<!--            <img src="@/assets/user/img/free-icon-giftbox-8762962.png">-->
<!--            <span>기획전</span>-->
<!--          </a>-->
          <a href="/mypage/faq" class="mobile-menu-common-link" @click="closeMenu">
            <img src="@/assets/user/img/free-icon-customer-review-9821148.png">
            <span>고객센터</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'NebulaHeader',
  data() {
    return {
      isLoggedIn: false,
      userName: '',
      cartItemCount: 0, // 장바구니 아이템 수량
      // 모달 관련 데이터 추가
      showModal: false,
      modalType: 'category', // 'category' 또는 'brand'
      // 슬라이드 관련 데이터 추가
      currentSlide: 0,
      promotionSlides: [
        // {
        //   type: 'kakao',
        //   icon: 'bi-chat-fill',
        //   title: '1000포인트 받아가세요~',
        //   subtitle: '카카오채널 친구추가 이벤트',
        //   bgColor: '#FFEB3B',
        //   iconBgColor: '#FEE500'
        // },
        // {
        //   type: 'gift',
        //   icon: 'bi-gift-fill',
        //   title: '신규 가입 특별 혜택',
        //   subtitle: '회원가입 시 5,000원 쿠폰 증정',
        //   bgColor: '#E3F2FD',
        //   iconBgColor: '#2196F3'
        // },
        {
          type: 'shipping',
          icon: 'bi-truck',
          title: '30만원 이상 무료배송',
          subtitle: '빠르고 안전한 배송서비스',
          bgColor: '#E8F5E9',
          iconBgColor: '#4CAF50'
        },
        {
          type: 'discount',
          icon: 'bi-percent',
          title: '대량 구매 할인 제공',
          subtitle: '신규 회원 전용 특별 혜택',
          bgColor: '#FFF3E0',
          iconBgColor: '#FF9800'
        }
      ],
      slideInterval: null,
      loading: true,
      showPromoBanner: true,
      searchQuery: '',
      showCategoryMenu: false,
      isMobile: false,
      showMobileMenu: false,
      showMobileSearch: false,
      selectedCategoryIndex: 0,
      mobileSelectedCategory: 0,
      categories: [
        {
          name: '전동공구',
          icon: require('@/assets/user/icon/free-icon-power-tool-4647569.png'), // 아이콘은 적절한 것으로 변경 필요
          bannerImage: require('@/assets/user/img/banner/카테고리배너_0000_카테고리배너_전동.png'),
          subCategories: [
            {
              title: '드릴/드라이버',
              items: ['충전 드릴', '임팩트 드라이버', '함마드릴', '전기드릴', '코드리스 드릴']
            },
            {
              title: '절단/연마',
              items: ['그라인더', '샌더', '절단기', '원형톱', '직소']
            },
            {
              title: '용접/조립',
              items: ['용접기', '토치', '리벳건', '스테이플러', '타카']
            }
          ]
        },
        {
          name: '수공구',
          icon: require('@/assets/user/icon/free-icon-screwdriver-11509066.png'), // 아이콘은 적절한 것으로 변경 필요
          bannerImage: require('@/assets/user/img/banner/카테고리배너_0001_카테고리배너_수공구.png'),
          subCategories: [
            {
              title: '핸드툴',
              items: ['렌치/스패너', '드라이버', '해머/망치', '니퍼/플라이어', '바이스']
            },
            {
              title: '측정공구',
              items: ['줄자/자', '버니어캘리퍼스', '수평계', '각도기', '디지털 측정기']
            },
            {
              title: '목공구',
              items: ['목공용 클램프', '대패', '끌/조각도', '사포/샌딩', '톱']
            }
          ]
        },
        {
          name: '안전용품',
          icon: require('@/assets/user/icon/free-icon-safety-4429965.png'), // 아이콘은 적절한 것으로 변경 필요
          bannerImage: require('@/assets/user/img/banner/카테고리배너_0002_카테고리배너_안전용품.png'),
          subCategories: [
            {
              title: '개인보호구',
              items: ['안전모', '안전화', '안전장갑', '보안경', '귀마개/귀덮개']
            },
            {
              title: '작업복',
              items: ['작업복 상의', '작업복 하의', '작업복 세트', '방진복', '안전조끼']
            },
            {
              title: '안전장비',
              items: ['안전벨트/안전대', '환풍기', '마스크', '소화기', '응급처치용품']
            }
          ]
        },
        {
          name: '자재/부자재',
          icon: require('@/assets/user/icon/free-icon-steel-joist-14679849.png'), // 아이콘은 적절한 것으로 변경 필요
          bannerImage: require('@/assets/user/img/banner/카테고리배너_0003_카테고리배너_자재.png'),
          subCategories: [
            {
              title: '철물',
              items: ['나사/볼트/너트', '못/피스', '앵커', '경첩/도어록', '고리/와이어']
            },
            {
              title: '배관/전기',
              items: ['파이프/연결구', '밸브/게이트', '전선/케이블', '콘센트/스위치', '전기테이프']
            },
            {
              title: '접착/실란트',
              items: ['접착제', '실리콘', '에폭시', '테이프류', '본드/글루']
            }
          ]
        },
        {
          name: '작업장비',
          icon: require('@/assets/user/icon/free-icon-milling-machine-2162521.png'), // 아이콘은 적절한 것으로 변경 필요
          bannerImage: require('@/assets/user/img/banner/카테고리배너_0004_카테고리배너_작업장비.png'),
          subCategories: [
            {
              title: '작업대/수납',
              items: ['작업대', '공구함', '부품함', '수납선반', '이동식 카트']
            },
            {
              title: '발전/조명',
              items: ['발전기', 'LED작업등', '랜턴', '헤드랜턴', '투광기']
            },
            {
              title: '운반장비',
              items: ['핸드카트', '대차', '리프트', '사다리', '호이스트']
            }
          ]
        },
        {
          name: '측정/계측',
          icon: require('@/assets/user/icon/free-icon-electric-meter-4264744.png'), // 아이콘은 적절한 것으로 변경 필요
          bannerImage: require('@/assets/user/img/banner/카테고리배너_0005_카테고리배너_측정.png'),
          subCategories: [
            {
              title: '전기측정',
              items: ['멀티미터', '클램프미터', '테스터기', '전압계', '전류계']
            },
            {
              title: '레이저/광학',
              items: ['레이저 레벨기', '레이저 거리측정기', '열화상 카메라', '내시경 카메라', '망원경']
            },
            {
              title: '온습도/압력',
              items: ['온습도계', '압력계', '풍속계', '소음계', 'PH측정기']
            }
          ]
        }
      ],
      // 브랜드 데이터
      // 브랜드 데이터 (이미지 없이 텍스트만 사용)
      brands: [
        // 한글 브랜드
        {
          letter: 'ㄱ',
          items: [
            { name: '계양전기', logo: null },
            { name: '그랜드터크', logo: null },
            { name: '기가한', logo: null }
          ]
        },
        {
          letter: 'ㄴ',
          items: [
            { name: '나이키스', logo: null },
            { name: '뉴웰', logo: null }
          ]
        },
        {
          letter: 'ㄷ',
          items: [
            { name: '대원전기', logo: null },
            { name: '두산공구', logo: null }
          ]
        },
        // 영문 브랜드
        {
          letter: 'A',
          items: [
            { name: 'AEG', logo: null },
            { name: 'Atlas Copco', logo: null }
          ]
        },
        {
          letter: 'B',
          items: [
            { name: 'Black & Decker', logo: null },
            { name: 'Bosch', logo: null },
            { name: 'Bostitch', logo: null }
          ]
        },
        {
          letter: 'D',
          items: [
            { name: 'DeWalt', logo: null },
            { name: 'Dremel', logo: null }
          ]
        },
        {
          letter: 'H',
          items: [
            { name: 'Hilti', logo: null },
            { name: 'Hitachi', logo: null }
          ]
        },
        {
          letter: 'M',
          items: [
            { name: 'Makita', logo: null },
            { name: 'Milwaukee', logo: null },
            { name: 'Metabo', logo: null }
          ]
        },
        {
          letter: 'S',
          items: [
            { name: 'Stanley', logo: null },
            { name: 'Snap-on', logo: null }
          ]
        }
      ]
    };
  },
  computed: {
    selectedCategory() {
      return this.categories[this.selectedCategoryIndex];
    },
    koreanBrands() {
      return this.brands.filter(brand => /^[ㄱ-ㅎ]$/.test(brand.letter));
    },
    englishBrands() {
      return this.brands.filter(brand => /^[A-Z]$/.test(brand.letter));
    }
  },
  created() {
    // 초기 모바일 상태 확인
    this.checkIsMobile();
    // 로그인 상태 확인
    this.checkLoginStatus();
    // 카테고리 데이터 로드 추가
    this.fetchCategories();
    // 장바구니 수량 가져오기
    this.fetchCartItemCount();
  },
  mounted() {
    // 초기 모바일 체크
    this.checkMobile();

    // 창 크기 변경 시 모바일 체크
    window.addEventListener('resize', this.checkMobile);
    // 이미지 프리로딩 추가
    this.preloadCategoryImages();
    // 슬라이드쇼 시작
    this.startSlideShow();
    // 스켈레톤 UI를 2초 동안 보여준 후 컨텐츠를 로드
    setTimeout(() => {
      this.loading = false;
    }, 2000);

    // 카테고리 메뉴가 열려있을 때 외부 클릭 감지
    document.addEventListener('click', this.handleOutsideClick);

    // 창 크기 변경 이벤트 리스너 추가
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    // 슬라이드쇼 중지
    this.stopSlideShow();
    // 컴포넌트 제거 시 이벤트 리스너 제거
    document.removeEventListener('click', this.handleOutsideClick);
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    addToFavorites() {
      // 사이트 제목 가져오기 (관리자 설정값 사용)
      const title = document.title || '마이툴 - 공구 쇼핑몰';

      if (window.sidebar && window.sidebar.addPanel) { // Firefox
        window.sidebar.addPanel(title, window.location.href, '');
      } else if (window.external && ('AddFavorite' in window.external)) { // IE
        window.external.AddFavorite(window.location.href, title);
      } else { // Chrome, Safari, Opera, etc.
        alert(`${title}\n${window.location.href}\n\n키보드 단축키를 이용해주세요:\n- Windows: Ctrl + D\n- Mac: Command + D`);
      }
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768; // 768px 이하를 모바일로 간주
    },
    // 로그인 상태 확인
    checkLoginStatus() {
      // 로컬 스토리지에서 인증 토큰과 사용자 정보 확인
      const token = localStorage.getItem('auth_token');
      const userInfo = localStorage.getItem('user_info');

      if (token && userInfo) {
        const user = JSON.parse(userInfo);
        this.isLoggedIn = true;
        this.userName = user.name || '사용자';
        this.fetchCartItemCount();
      } else {
        this.isLoggedIn = false;
        this.userName = '';
      }
    },
// 장바구니 수량 가져오기
    fetchCartItemCount() {
      // 로그인한 상태일 때만 API 호출
      if (this.isLoggedIn) {
        const token = localStorage.getItem('auth_token');

        axios.get('/api/user/cart', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
            .then(response => {
              if (response.data && response.data.items) {
                // 장바구니에 있는 모든 아이템 수량 합계
                this.cartItemCount = response.data.items.length;
              } else {
                this.cartItemCount = 0;
              }
            })
            .catch(error => {
              console.error('장바구니 정보를 가져오는 중 오류 발생:', error);
              this.cartItemCount = 0;
            });
      } else {
        // 로그인하지 않은 경우 로컬 스토리지의 장바구니 확인 (필요시 구현)
        const localCart = localStorage.getItem('guest_cart');
        if (localCart) {
          try {
            const cartData = JSON.parse(localCart);
            this.cartItemCount = cartData.length || 0;
          } catch (e) {
            this.cartItemCount = 0;
          }
        } else {
          this.cartItemCount = 0;
        }
      }
    },
    // 로그아웃 처리
    handleLogout() {
      // 로컬 스토리지에서 인증 관련 정보 삭제
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user_info');

      // 로그인 상태 업데이트
      this.isLoggedIn = false;
      this.userName = '';
      this.cartItemCount = 0; // 장바구니 수량 초기화

      // 로그인 페이지로 이동
      this.$router.push('/login');
    },
    // 이미지 프리로딩 메소드 추가
    preloadCategoryImages() {
      // 모든 카테고리 이미지 프리로딩
      this.categories.forEach(category => {
        if (category.bannerImage) {
          const img = new Image();
          img.src = category.bannerImage;
        }
      });
    },

    // 카테고리 모달 열기
    openCategoryModal(type) {
      this.modalType = type;
      this.showModal = true;
      document.body.style.overflow = 'hidden'; // 스크롤 방지
    },

    // 모달 닫기
    closeModal() {
      this.showModal = false;
      document.body.style.overflow = ''; // 스크롤 복원
    },

// methods 안에 추가
    async fetchCategories() {
      try {
        console.log('카테고리 데이터 로딩 시작...');

        const response = await axios.get('/api/products/categories');

        console.log('API 응답 상태:', response.status);
        console.log('응답 데이터:', response.data);

        if (response.data && Array.isArray(response.data)) {
          let categoriesToUse = [];

          // 전체카테고리만 있고 children이 있는 경우
          if (response.data.length === 1 &&
              response.data[0].name === '전체카테고리' &&
              response.data[0].children &&
              response.data[0].children.length > 0) {

            console.log('전체카테고리의 하위 카테고리(children) 사용');
            categoriesToUse = response.data[0].children;
          } else {
            categoriesToUse = response.data;
          }

          // 비활성화된 카테고리 필터링 (active가 false인 것 제외)
          categoriesToUse = categoriesToUse.filter(cat =>
            cat.active === undefined || cat.active === true
          );

          // 각 카테고리별 아이콘 매핑
          const iconMap = {
            '전동공구': require('@/assets/user/icon/free-icon-power-tool-4647569.png'),
            '수공구': require('@/assets/user/icon/free-icon-screwdriver-11509066.png'),
            '안전용품': require('@/assets/user/icon/free-icon-safety-4429965.png'),
            '자재/부자재': require('@/assets/user/icon/free-icon-steel-joist-14679849.png'),
            '작업장비': require('@/assets/user/icon/free-icon-milling-machine-2162521.png'),
            '측정/계측': require('@/assets/user/icon/free-icon-electric-meter-4264744.png')
          };

          // 기본 아이콘 배열
          const defaultIcons = [
            require('@/assets/user/icon/free-icon-power-tool-4647569.png'),
            require('@/assets/user/icon/free-icon-screwdriver-11509066.png'),
            require('@/assets/user/icon/free-icon-safety-4429965.png'),
            require('@/assets/user/icon/free-icon-steel-joist-14679849.png'),
            require('@/assets/user/icon/free-icon-milling-machine-2162521.png'),
            require('@/assets/user/icon/free-icon-electric-meter-4264744.png')
          ];

          const transformedCategories = categoriesToUse.map((category, index) => {
            const iconPath = iconMap[category.name] || defaultIcons[index % defaultIcons.length];

            // 배너 이미지 매핑
            const bannerMap = {
              '전동공구': require('@/assets/user/img/banner/카테고리배너_0000_카테고리배너_전동.png'),
              '수공구': require('@/assets/user/img/banner/카테고리배너_0001_카테고리배너_수공구.png'),
              '안전용품': require('@/assets/user/img/banner/카테고리배너_0002_카테고리배너_안전용품.png'),
              '자재/부자재': require('@/assets/user/img/banner/카테고리배너_0003_카테고리배너_자재.png'),
              '작업장비': require('@/assets/user/img/banner/카테고리배너_0004_카테고리배너_작업장비.png'),
              '측정/계측': require('@/assets/user/img/banner/카테고리배너_0005_카테고리배너_측정.png')
            };

            const bannerPath = bannerMap[category.name] ||
                require(`@/assets/user/img/banner/카테고리배너_000${index % 6}_카테고리배너_${
                    ['전동', '수공구', '안전용품', '자재', '작업장비', '측정'][index % 6]
                }.png`);

            console.log(`카테고리 ${category.name} 아이콘:`, iconPath);

            // children을 subCategories로 매핑 (비활성화된 카테고리 제외)
            const activeChildren = category.children
              ? category.children.filter(child => child.active === undefined || child.active === true)
              : [];

            const subCategories = activeChildren.map(child => ({
              title: child.name,
              items: child.children
                ? child.children
                    .filter(grandChild => grandChild.active === undefined || grandChild.active === true)
                    .map(grandChild => grandChild.name)
                : []
            }));

            return {
              name: category.name,
              icon: iconPath,
              bannerImage: bannerPath,
              subCategories: subCategories // children을 변환하여 사용
            };
          });

          console.log('변환된 카테고리 데이터:', transformedCategories);
          this.categories = transformedCategories;
        }
      } catch (error) {
        console.error('카테고리 로딩 중 오류가 발생했습니다:', error);
        console.log('기본 카테고리 데이터를 사용합니다.');
        // 기본 카테고리 데이터 유지
      }
    },

    // 카테고리 아이템 클릭 처리
    handleCategoryItemClick(item) {
      // 카테고리 페이지로 이동
      this.$router.push({
        path: '/category',
        query: { category: item }
      });
    },

// 슬라이드 관련 메서드
    nextSlide() {
      // 애니메이션이 끝나면 다음 슬라이드로 이동
      this.currentSlide = (this.currentSlide + 1) % this.promotionSlides.length;

      // 강제로 DOM 업데이트 (Vue의 반응형 시스템 강제 업데이트)
      this.$nextTick(() => {
        const container = document.querySelector('.nebula-slide-container');
        if (container) {
          container.style.transform = `translateX(-${this.currentSlide * 25}%)`;
        }
      });
    },

    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.promotionSlides.length) % this.promotionSlides.length;

      this.$nextTick(() => {
        const container = document.querySelector('.nebula-slide-container');
        if (container) {
          container.style.transform = `translateX(-${this.currentSlide * 25}%)`;
        }
      });
    },

    goToSlide(index) {
      this.currentSlide = index;

      this.$nextTick(() => {
        const container = document.querySelector('.nebula-slide-container');
        if (container) {
          container.style.transform = `translateX(-${this.currentSlide * 25}%)`;
        }
      });
    },

    startSlideShow() {
      this.slideInterval = setInterval(() => {
        this.nextSlide();
      }, 5000); // 5초마다 슬라이드 변경
    },

    stopSlideShow() {
      if (this.slideInterval) {
        clearInterval(this.slideInterval);
      }
    },
    // Header.vue의 closePromoBanner 메서드 수정
    closePromoBanner() {
      this.showPromoBanner = false;
      // 실제 구현에서는 쿠키나 로컬 스토리지에 1일간 보지 않기 상태 저장

      // 전역 커스텀 이벤트 발생 - 다른 컴포넌트에서 감지할 수 있도록
      this.$nextTick(() => {
        if (window.dispatchEvent) {
          window.dispatchEvent(new CustomEvent('header-height-changed'));
        }
      });
    },
    searchProducts() {
      if (this.searchQuery.trim() !== '') {
        // 검색어로 상품 페이지로 이동 - 제품코드와 제품명 모두 검색 가능하도록 수정
        this.$router.push({
          path: '/products',
          query: {
            keyword: this.searchQuery.trim(),
            searchType: 'all'  // 🔥 모든 필드 검색 옵션 추가
          }
        });

        // 모바일 검색창이 열려 있다면 닫기
        if (this.showMobileSearch) {
          this.showMobileSearch = false;
        }

        // 검색 후 검색어 초기화 (선택 사항)
        // this.searchQuery = '';
      } else {
        // 검색어가 없는 경우 알림 (선택 사항)
        alert('검색어를 입력해주세요.');
      }
    },
    getIdForCategory(categoryName) {
      // 카테고리 이름으로 ID를 찾는 함수
      const categoryMap = {
        // 전동공구 관련
        '전동공구': 2,
        '드릴/드라이버': 8,
        '충전 드릴': 113,
        '임팩트 드라이버': 114,
        '함마드릴': 115,
        '전기드릴': 116,
        '코드리스 드릴': 117,

        // 절단/연마 관련
        '절단/연마': 9,
        '그라인더': 53,
        '샌더': 54,
        '절단기': 55,
        '원형톱': 56,
        '직소': 57,

        // 용접/조립 관련
        '용접/조립': 20,
        '용접기': 78,
        '토치': 79,
        '리벳건': 80,
        '스테이플러': 81,
        '타카': 82,

        // 수공구 관련
        '수공구': 3,

        // 안전용품 관련
        '안전용품': 4,

        // 자재/부자재 관련
        '자재/부자재': 5,

        // 작업장비 관련
        '작업장비': 6,

        // 측정/계측 관련
        '측정/계측': 7,
      };

      return categoryMap[categoryName] || encodeURIComponent(categoryName);
    },
    toggleCategoryMenu(event) {
      event.stopPropagation();
      this.showCategoryMenu = !this.showCategoryMenu;
    },
    // 기존 selectCategory 메서드 대신 이렇게 변경
    // selectCategory 메소드 수정
    selectCategory(index) {
      // 동일한 카테고리 클릭 시 중복 처리 방지
      if (this.selectedCategoryIndex === index) {
        return;
      }

      // 화면 업데이트 최적화를 위한 Vue nextTick 사용
      this.selectedCategoryIndex = index;
      this.$nextTick(() => {
        // DOM 업데이트 후 실행할 코드가 있다면 여기에 추가
      });
    },
    selectMobileCategory(index) {
      this.mobileSelectedCategory = index;
    },
    handleOutsideClick(event) {
      const dropdown = document.querySelector('.nebula-category-dropdown');
      if (dropdown && !dropdown.contains(event.target) && this.showCategoryMenu) {
        this.showCategoryMenu = false;
      }
    },
    // 모바일 메뉴 토글
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;

      // 모바일 메뉴가 열리면 검색창은 닫기
      if (this.showMobileMenu) {
        this.showMobileSearch = false;
      }

      // 메뉴가 열리면 스크롤 방지
      if (this.showMobileMenu) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    // 모바일 검색창 토글
    toggleMobileSearch() {
      this.showMobileSearch = !this.showMobileSearch;

      // 검색창이 열리면 메뉴는 닫기
      if (this.showMobileSearch) {
        this.showMobileMenu = false;
      }
    },
    // 창 크기 변경 처리
    handleResize() {
      this.checkIsMobile();

      // 모바일에서 PC로 전환될 때 모바일 메뉴와 검색창 닫기
      if (!this.isMobile) {
        this.showMobileMenu = false;
        this.showMobileSearch = false;
        document.body.style.overflow = '';
      }
    },
    // 모바일 여부 확인
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    // 메뉴 닫기
    closeMenu() {
      this.showMobileMenu = false;
      document.body.style.overflow = '';
    },

    navigateToCategoryAndCloseModal(path) {
      // 모달 닫기
      this.closeModal();
      // 페이지 이동 (라우터 객체 사용)
      this.$router.push(path);
    }
  }
};
</script>

<style scoped>
/* 공통 헤더 기본 스타일 */
.nebula-header-wrapper {
  font-family: 'Noto Sans KR', sans-serif;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1100;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.nebula-container {
  max-width: 1900px;
  margin: 0 auto;
  padding: 0 15px;
}

/* 스켈레톤 UI 스타일 */
.nebula-header-skeleton {
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% { opacity: 0.6; }
  50% { opacity: 1; }
  100% { opacity: 0.6; }
}

.nebula-skeleton-promotion-banner {
  background-color: #e0e0e0;
  padding: 10px 0;
}

.nebula-skeleton-promotion-content {
  height: 24px;
  width: 60%;
  margin: 0 auto;
  background-color: #d0d0d0;
  border-radius: 4px;
}

.nebula-skeleton-top-header {
  background-color: white;
  border-bottom: 1px solid #eee;
  padding: 10px 0;
}

.nebula-skeleton-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nebula-skeleton-header-left {
  display: flex;
  align-items: center;
}

.nebula-skeleton-logo {
  width: 80px;
  height: 24px;
  background-color: #e0e0e0;
  margin-right: 15px;
  border-radius: 4px;
}

.nebula-skeleton-favorite {
  width: 110px;
  height: 24px;
  background-color: #e0e0e0;
  border-radius: 4px;
}

.nebula-skeleton-header-right {
  display: flex;
  align-items: center;
}

.nebula-skeleton-utility-icons {
  display: flex;
  margin-right: 15px;
}

.nebula-skeleton-icon {
  width: 24px;
  height: 24px;
  background-color: #e0e0e0;
  border-radius: 50%;
  margin-left: 15px;
}

.nebula-skeleton-auth-buttons {
  display: flex;
}

.nebula-skeleton-btn {
  width: 60px;
  height: 24px;
  background-color: #e0e0e0;
  border-radius: 4px;
  margin-left: 10px;
}

.nebula-skeleton-main-header {
  background-color: white;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
}

.nebula-skeleton-main-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nebula-skeleton-main-logo {
  width: 150px;
  height: 60px;
  background-color: #e0e0e0;
  border-radius: 4px;
}

.nebula-skeleton-search-bar {
  width: 40%;
  height: 44px;
  background-color: #e0e0e0;
  border-radius: 4px;
}

.nebula-skeleton-kakao-promo {
  width: 250px;
  height: 56px;
  background-color: #e0e0e0;
  border-radius: 6px;
}

.nebula-skeleton-main-nav {
  background-color: white;
  padding: 10px 0;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.nebula-skeleton-nav-content {
  display: flex;
  justify-content: space-between;
}

.nebula-skeleton-primary-nav {
  display: flex;
}

.nebula-skeleton-nav-item {
  width: 100px;
  height: 20px;
  background-color: #e0e0e0;
  border-radius: 4px;
  margin-right: 20px;
}

.nebula-skeleton-secondary-nav {
  display: flex;
}

.nebula-skeleton-nav-item-small {
  width: 70px;
  height: 20px;
  background-color: #e0e0e0;
  border-radius: 4px;
  margin-left: 15px;
}

/* 실제 컨텐츠 페이드인 애니메이션 */
.nebula-header-wrapper > div:not(.nebula-header-skeleton) {
  opacity: 0;
  animation: fadeIn 0.5s forwards;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* 프로모션 배너 스타일 */
.nebula-promotion-banner {
  background-color: #F9B600;
  color: black;
  padding: 5px 0;
}

.nebula-promotion-content {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.nebula-icon {
  font-size: 24px;
  margin: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nebula-promotion-text {
  font-size: 16px;
  font-weight: 500;
}

.nebula-close-btn {
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  background: none;
  border: none;
  color: white;
  font-size: 12px;
  cursor: pointer;
}

.nebula-close-btn i {
  font-size: 16px;
  margin-left: 5px;
}

/* 상단 헤더 스타일 */
.nebula-top-header {
  background-color: #133958;
  border-bottom: 1px solid #2b2b2b;
  padding: 5px 0;
}

.nebula-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nebula-header-left {
  display: flex;
  align-items: center;
}

.nebula-logo-link {
  margin-right: 15px;
  text-decoration: none;
}

.nebula-text-logo {
  font-size: 16px;
  font-weight: 600;
  padding: 0px 10px;
  border-radius: 4px;
  text-decoration: none;
}

.supporting-dream {
  color: #3a87ad;
  background-color: #f5f5f5;
}

.doctor-market {
  color: #4a6cf7;
  background-color: #f5f5f5;
}

.nebula-favorite-btn {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  color: #ffffff;
  font-size: 13px;
  cursor: pointer;
}

.nebula-favorite-btn i {
  color: #ffc107;
  margin-right: 5px;
}

.nebula-header-link {
  display: flex;
  align-items: center;
  color: #ffffff;
  font-size: 13px;
  text-decoration: none;
  margin-left: 15px;
}

.nebula-header-link i {
  margin-right: 5px;
}

.nebula-header-link:hover {
  color: #ffc107;
}

/* 모바일 최상단 바로가기 */
.nebula-header-left-mobile {
  display: flex;
  align-items: center;
  gap: 6px;
}

.mobile-header-link {
  display: flex;
  align-items: center;
  color: #ffffff;
  font-size: 11px;
  text-decoration: none;
  padding: 3px 6px;
  background: rgba(255,255,255,0.15);
  border-radius: 3px;
}

.mobile-header-link i {
  margin-right: 3px;
  font-size: 11px;
}

.mobile-header-link:hover {
  background: rgba(255,255,255,0.25);
}

.nebula-header-right {
  display: flex;
  align-items: center;
}

.nebula-utility-icons {
  display: flex;
  margin-right: 15px;
}

.nebula-icon-btn {
  position: relative;
  background: none;
  border: none;
  margin-left: 15px;
  font-size: 20px;
  color: #555;
  cursor: pointer;
}

.nebula-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #dc3545;
  color: white;
  font-size: 10px;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nebula-auth-buttons {
  display: flex;
}

.nebula-btn {
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  border: none;
  background: none;
}

.nebula-login-btn {
  color: #555;
}

.nebula-signup-btn {
  color: #333;
  font-weight: 500;
}

/* 메인 헤더 스타일 */
.nebula-main-header {
  background-color: #194263;
  padding: 15px 0;
  border-bottom: 0px solid #eee;
  position: relative;
}

.nebula-main-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* 빠른 카테고리 링크 스타일 */
.nebula-quick-categories {
  display: flex;
  align-items: center;
  margin-right: 20px;
  flex-shrink: 0;
}

.nebula-quick-category-link {
  display: flex;
  align-items: center;
  flex-direction: column;
  color: #ffffff;
  text-decoration: none;
  padding: 0 10px;
  margin: 0 5px;
  font-size: 16px;
  transition: color 0.2s;
}

.nebula-quick-category-link i {
  font-size: 25px;
  margin-bottom: 5px;
}

.nebula-quick-category-link:hover {
  color: #F9B600;
}

/* 카테고리 구분선 */
.nebula-category-divider {
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
  margin: 0 5px;
}

/* 프로모션 슬라이드 크기 조정 */
.nebula-promotion-slide {
  flex-shrink: 0;
  width: 250px;
}
.nebula-main-logo {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.nebula-main-logo img {
  max-width: 100%;
  height: auto;
}

.nebula-main-logo-text {
  font-size: 26px;
  font-weight: 700;
  color: #4a6cf7;
  display: flex;
  align-items: center;
}

.nebula-main-logo-text i {
  margin-right: 10px;
  color: #4a6cf7;
}

.nebula-tagline {
  font-size: 12px;
  color: #666;
  margin-top: 5px;
}

.nebula-header-wrapper .nebula-search-bar .nebula-search-btn {
  position: relative; /* 위치 조정을 위해 추가 */
  background-color: #F9B600;
  color: white;
  border: none;
  padding: 0 15px;
  cursor: pointer;
  font-size: 16px;
  flex-shrink: 0;
  min-width: 45px;
  height: 38px; /* 입력창과 동일한 높이 */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2; /* 다른 요소보다 앞에 표시 */
  right: 0; /* 오른쪽 끝에 붙임 */
  border-radius: 0 4px 4px 0; /* 오른쪽만 둥글게 */
  box-sizing: border-box;
}

.nebula-header-wrapper .nebula-search-bar {
  position: relative; /* 버튼 위치 조정을 위해 필요 */
  display: flex;
  align-items: center;
  width: 40%;
  border: 0px solid #4a6cf7;
  border-radius: 4px;
  /* overflow 속성 제거 */
}

.nebula-header-wrapper .nebula-search-input {
  width: 50%;
  padding: 0 15px;
  height: 38px; /* 버튼과 동일한 높이 */
  border: none;
  outline: none;
  font-size: 14px;
  border-radius: 4px 0 0 4px; /* 왼쪽만 둥글게 */
  box-sizing: border-box;
}

.nebula-kakao-promo {
  display: flex;
  align-items: center;
  background-color: #FFEB3B;
  padding: 10px;
  border-radius: 6px;
}
/* 프로모션 슬라이드 스타일 수정 */
.nebula-promotion-slide {
  position: relative;
  width: 250px;
  height: 60px; /* 높이를 더 정확하게 설정 */
  overflow: hidden;
  border-radius: 6px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.nebula-slide-container {
  display: flex;
  width: 400%;
  height: 100%;
  transition: all 0.5s ease; /* transform 대신 all로 변경 */
  will-change: transform; /* 성능 최적화 */
}

.nebula-slide-item {
  flex: 0 0 25%;
  width: 25%; /* 명시적으로 너비 지정 */
  height: 100%;
  display: flex;
  align-items: center;
  padding: 10px;
  color: #333;
  box-sizing: border-box; /* 패딩이 너비에 포함되도록 설정 */
}

/* 각 슬라이드 아이템에 확실한 배경색 지정 */
/* 각 슬라이드 아이템 배경색 */
.nebula-slide-item.nebula-kakao-promo {
  background-color: #FFEB3B !important;
}

.nebula-slide-item.nebula-new-promo {
  background-color: #E3F2FD !important;
}

.nebula-slide-item.nebula-shipping-promo {
  background-color: #E8F5E9 !important;
}

.nebula-slide-item.nebula-discount-promo {
  background-color: #FFF3E0 !important;
}

/* 각 슬라이드 아이콘 스타일 명확히 지정 */
.nebula-kakao-icon i {
  font-size: 30px;
  color: #3b1e1e;
  background-color: #FEE500;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.nebula-promo-icon i {
  font-size: 30px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.nebula-slide-item.nebula-new-promo .nebula-promo-icon i {
  color: white;
  background-color: #2196F3;
}

.nebula-slide-item.nebula-shipping-promo .nebula-promo-icon i {
  color: white;
  background-color: #4CAF50;
}

.nebula-slide-item.nebula-discount-promo .nebula-promo-icon i {
  color: white;
  background-color: #FF9800;
}

/* 텍스트 스타일 명확히 지정 */
.nebula-kakao-text,
.nebula-promo-text {
  font-size: 12px;
  flex-grow: 1;
  overflow: hidden;
  color: #333; /* 확실한 텍스트 색상 지정 */
  padding-top: 10px; /* 상단 패딩 제거 */
  margin-top: -15px; /* 위로 5px 올림 */
  margin-left:10px
}

.nebula-kakao-title,
.nebula-promo-title {
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #333; /* 확실한 텍스트 색상 지정 */
}

.nebula-kakao-subtitle,
.nebula-promo-subtitle {
  margin: 0;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 슬라이드 네비게이션 */
.nebula-slide-nav {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nebula-slide-btn {
  background: none;
  border: none;
  color: rgba(0, 0, 0, 0.5);
  font-size: 12px;
  cursor: pointer;
  padding: 0 5px;
}

.nebula-slide-indicators {
  display: flex;
  margin: 0 5px;
}

.nebula-slide-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.3);
  margin: 0 3px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.nebula-slide-dot.active {
  background-color: rgba(0, 0, 0, 0.7);
}
.nebula-kakao-icon {
  margin-right: 10px;
  flex-shrink: 0;
}

.nebula-kakao-icon i {
  font-size: 30px;
  color: #3b1e1e;
  background-color: #FEE500;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.nebula-kakao-text {
  font-size: 12px;
  flex-grow: 1;
  overflow: hidden;
}

.nebula-kakao-title {
  font-weight: 500;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nebula-kakao-subtitle {
  margin: 0;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 메인 네비게이션 스타일 */
.nebula-main-nav {
  background-color: white;
  padding: 10px 0;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
  position: relative;
  z-index: 50;
}

.nebula-nav-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nebula-primary-nav {
  display: flex;
  flex-wrap: wrap;
}

.nebula-nav-item {
  display: flex;
  align-items: center;
  margin-right: 20px;
  color: #333;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 5px;
}

.nebula-nav-item img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.nebula-nav-item i, .nebula-nav-icon {
  margin-right: 5px;
  font-size: 16px;
}

.nebula-secondary-nav {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.nebula-secondary-nav-item {
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: #666;
  text-decoration: none;
  font-size: 13px;
  border: 1px solid #CCCCCC;
  padding: 5px;
  border-radius: 5px;
  margin-bottom: 5px;
}

.nebula-secondary-nav-item img {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.nebula-secondary-nav-item i {
  margin-right: 5px;
  font-size: 14px;
}

.nebula-more-menu {
  margin-left: 15px;
  font-size: 16px;
  color: #666;
  cursor: pointer;
}

/* 카테고리 드롭다운 메뉴 스타일 */
.nebula-category-dropdown {
  position: relative;
}

.nebula-category-menu {
  position: absolute;
  top: 100%;
  left: 0;
  display: flex;
  width: 1200px;
  max-width: 100vw;
  background-color: white;
  border: 1px solid #eee;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  z-index: 1000;
  border-radius: 4px;
  margin-top: 10px;
}

.nebula-category-left {
  width: 220px;
  background-color: #f8f8f8;
  padding: 20px 0;
  border-right: 1px solid #eee;
  min-height: 400px;
  flex-shrink: 0;
}

.nebula-category-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nebula-category-item {
  padding: 0;
  height: 48px; /* 모든 카테고리 항목의 높이를 동일하게 설정 */
  display: block; /* 블록 레벨 요소로 변경 */
}

.nebula-category-link {
  display: flex;
  align-items: center;
  padding: 0 20px; /* 좌우 패딩만 설정 */
  color: #333;
  text-decoration: none;
  font-size: 14px;
  transition: background-color 0.2s;
  height: 100%; /* 부모 높이에 맞춤 */
  width: 100%; /* 너비 100%로 설정하여 호버 영역 확장 */
}

/* 호버 영역 개선 */
.nebula-category-left .nebula-category-list {
  position: relative; /* 부모 요소에 relative 설정 */
}

.nebula-category-link:hover {
  background-color: #e9ecef;
}
.nebula-category-dropdown .nebula-nav-item.active,
.nebula-category-dropdown .nebula-nav-item.active:hover {
  color: #4a6cf7;
  border-radius: 4px;
}

.nebula-category-dropdown .nebula-nav-item.active i,
.nebula-category-dropdown .nebula-nav-item.active:hover i {
  color: #4a6cf7;
}
.nebula-category-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.nebula-subcategory-right {
  flex: 1;
  padding: 20px;
  overflow: auto;
}

.nebula-subcategory-banner {
  margin-bottom: 20px;
}

.nebula-subcategory-banner img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
}

.nebula-subcategory-list {
  display: flex;
  flex-wrap: wrap;
}

.nebula-subcategory-group {
  width: 33.33%;
  padding: 0 10px 15px 0;
}

.nebula-subcategory-title {
  font-size: 14px;
  font-weight: 600;
  color: #4a6cf7;
  margin: 0 0 10px 0;
  padding-bottom: 5px;
  border-bottom: 1px solid #eee;
}

.nebula-subcategory-items {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nebula-subcategory-items li {
  margin-bottom: 6px;
}

.nebula-subcategory-link {
  color: #666;
  text-decoration: none;
  font-size: 13px;
  transition: color 0.2s;
}

.nebula-subcategory-link:hover {
  color: #4a6cf7;
  text-decoration: underline;
}

/* 모바일 메뉴 버튼 */
.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  color: white; /* 색상을 흰색으로 변경 */
  cursor: pointer;
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}

/* 모바일 상단 바로가기 링크 */
.mobile-top-links {
  display: none;
  position: absolute;
  left: 50px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  gap: 10px;
}

.mobile-top-link {
  display: flex;
  align-items: center;
  color: white;
  font-size: 11px;
  text-decoration: none;
  padding: 4px 8px;
  background: rgba(255,255,255,0.1);
  border-radius: 4px;
}

.mobile-top-link i {
  margin-right: 3px;
  font-size: 12px;
}

.mobile-top-link:hover {
  background: rgba(255,255,255,0.2);
}

/* 모바일 검색 버튼 */
.mobile-search-btn {
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  color: white; /* 색상을 흰색으로 변경 */
  cursor: pointer;
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}

/* 모바일 검색창 스타일 */
.mobile-search-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  padding: 10px 15px;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  z-index: 1000;
}

.mobile-search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.mobile-search-input {
  width: 100%;
  padding: 10px 80px 10px 15px;
  border: 2px solid #4a6cf7;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
}

.mobile-search-submit {
  position: absolute;
  right: 40px;
  background: none;
  border: none;
  font-size: 20px;
  color: #4a6cf7;
  cursor: pointer;
}

.mobile-search-close {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  color: #666;
  cursor: pointer;
}

/* 모바일 풀스크린 메뉴 */
.mobile-fullscreen-menu {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  z-index: 1100;
  overflow-y: auto;
  transition: transform 0.3s ease, opacity 0.3s ease;
  transform: translateY(-100%);
  opacity: 0;
}

.mobile-fullscreen-menu.active {
  display: block;
  transform: translateY(0);
  opacity: 1;
}

/* 모바일 대분류/중분류 메뉴 스타일 */
.mobile-category-container {
  display: flex;
  height: calc(100% - 150px); /* 헤더와 하단 공통 메뉴 영역 제외 */
  border-top: 1px solid #eee;
}

.mobile-category-main {
  width: 40%;
  background-color: #f8f8f8;
  overflow-y: auto;
  border-right: 1px solid #eee;
}

.mobile-category-item {
  display: flex;
  align-items: center;
  padding: 15px;
  color: #333;
  position: relative;
  border-bottom: 1px solid #f1f1f1;
}

.mobile-category-item.active {
  background-color: white;
  color: #4a6cf7;
  border-left: 3px solid #4a6cf7;
}

.mobile-category-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.mobile-category-item i {
  position: absolute;
  right: 15px;
  font-size: 12px;
}

.mobile-category-sub {
  width: 60%;
  padding: 15px;
  overflow-y: auto;
}

.mobile-subcategory-group {
  margin-bottom: 20px;
}

.mobile-subcategory-title {
  font-size: 16px;
  font-weight: 600;
  color: #4a6cf7;
  margin: 0 0 10px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

.mobile-subcategory-items {
  display: flex;
  flex-wrap: wrap;
}

.mobile-subcategory-link {
  width: 50%;
  padding: 8px 0;
  color: #333;
  text-decoration: none;
  font-size: 14px;
}

.mobile-subcategory-link:hover {
  color: #4a6cf7;
}

.mobile-menu-common-links {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-wrap: wrap;
  padding: 10px 15px;
  background-color: #f8f8f8;
  border-top: 1px solid #eee;
}

.mobile-menu-common-link {
  display: flex;
  align-items: center;
  width: 33.33%;
  padding: 10px;
  color: #333;
  text-decoration: none;
  font-size: 14px;
  text-align: center;
  justify-content: center;
}

.mobile-menu-common-link img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.mobile-menu-common-link i {
  font-size: 20px;
  margin-right: 5px;
}

/* 모바일 메뉴 헤더 */
.mobile-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.mobile-menu-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.mobile-menu-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #333;
  cursor: pointer;
}

/* 모바일 공통 클래스 */
.mobile-hidden {
  display: none !important;
}

/* 반응형 스타일 */
@media (max-width: 1200px) {
  .nebula-main-header-content {
    flex-wrap: wrap;
  }

  .nebula-main-logo {
    order: 1;
    margin-bottom: 15px;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .nebula-search-bar {
    order: 2;
    width: 60%;
    margin-bottom: 15px;
  }

  .nebula-kakao-promo {
    order: 3;
    width: 35%;
  }

  .nebula-category-menu {
    width: 90vw;
    max-width: 1000px;
  }
}

@media (max-width: 992px) {
  .nebula-category-menu {
    width: 90vw;
    max-width: 700px;
  }

  .nebula-subcategory-group {
    width: 50%;
  }

  .nebula-search-bar {
    width: 70%;
  }

  .nebula-kakao-promo {
    width: 25%;
  }
}

@media (max-width: 768px) {
  /* 모바일 메뉴 및 검색 버튼 표시 */
  .mobile-menu-btn,
  .mobile-search-btn {
    display: block;
  }

  /* 모바일 최상단 우측 간격 조정 */
  .nebula-header-right {
    margin-left: auto;
  }

  .nebula-utility-icons {
    margin-right: 0;
  }

  .nebula-icon-btn {
    margin-left: 5px;
  }

  .nebula-icon-btn svg {
    width: 20px;
    height: 20px;
  }

  .auth-buttons {
    margin-left: 2px;
  }

  .user-name {
    font-size: 9px;
    margin-right: 2px;
  }

  .logout-btn, .login-btn, .signup-btn {
    padding: 1px 3px;
    font-size: 9px;
    margin-left: 0;
  }

  /* 헤더 레이아웃 조정 */
  .nebula-main-header {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .nebula-main-header-content {
    justify-content: center;
    padding: 0 50px; /* 좌우 버튼 공간 확보 */
  }

  .nebula-main-logo {
    order: 1;
    margin: 0;
    width: auto;
  }

  .nebula-main-logo img {
    max-height: 40px;
  }

  /* 헤더 내 요소 조정 */
  .nebula-header-content {
    justify-content: flex-end;
  }
}

@media (max-width: 576px) {
  /* 로고 크기 조정 */
  .nebula-main-logo img {
    max-height: 35px;
  }

  /* 모바일 메뉴 조정 */
  .mobile-category-container {
    flex-direction: column;
  }

  .mobile-category-main {
    width: 100%;
    height: auto;
    max-height: 40vh;
    border-right: none;
    border-bottom: 1px solid #eee;
  }

  .mobile-category-sub {
    width: 100%;
    height: auto;
    max-height: calc(60vh - 150px);
  }

  .mobile-subcategory-link {
    width: 100%;
  }

  /* 검색창 조정 */
  .mobile-search-input {
    padding: 8px 70px 8px 10px;
    font-size: 13px;
  }

  /* 모바일 메뉴 공통 링크 조정 */
  .mobile-menu-common-link {
    font-size: 12px;
  }

  .mobile-menu-common-link img {
    width: 16px;
    height: 16px;
  }
}

/* 모달 스타일 */
.nebula-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
}

.nebula-modal-content {
  background-color: white;
  width: 70%; /* 80%에서 70%로 줄임 */
  max-width: 1200px; /* 1200px에서 1000px로 줄임 */
  max-height: 90vh; /* 90vh에서 80vh로 줄임 */
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  animation: modalFadeIn 0.3s;
}

@keyframes modalFadeIn {
  from { opacity: 0; transform: translateY(-30px); }
  to { opacity: 1; transform: translateY(0); }
}

.nebula-modal-header {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
}

.nebula-modal-header h3 {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: #333;
}

.nebula-modal-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #666;
  cursor: pointer;
  transition: color 0.2s;
}

.nebula-modal-close:hover {
  color: #4a6cf7;
}

.nebula-modal-body {
  flex-grow: 1;
  overflow: hidden;
}

.nebula-modal-category-container {
  display: flex;
  height: 100%;
  max-height: calc(90vh - 80px);
  overflow: hidden; /* 중요: 오버플로우 제어 */
}

.nebula-modal-category-left {
  width: 250px;
  background-color: #f8f8f8;
  overflow-y: auto;
  border-right: 1px solid #eee;
  flex-shrink: 0;
}

.nebula-modal-category-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nebula-modal-category-item {
  padding: 0;
  display: block;
  border-left: 3px solid transparent; /* 선택 표시를 위한 투명 보더 */
  transition: background-color 0.2s, border-left-color 0.2s;
}

.nebula-modal-category-item.active {
  background-color: #e9ecef;
  border-left-color: #4a6cf7;
}


/* 서브카테고리 컨테이너 최적화 */
.nebula-modal-subcategory-content {
  width: 100%;
  height: 100%;
  opacity: 1;
  transition: opacity 0.3s ease;
}


.nebula-modal-category-item.active .nebula-modal-category-link {
  color: #4a6cf7;
  font-weight: 500;
}

/* 카테고리 아이템 호버 스타일 개선 */
.nebula-modal-category-link:hover {
  background-color: #f2f2f2;
}

.nebula-modal-category-link {
  will-change: background-color;
  display: flex;
  align-items: center;
  padding: 15px 20px;
  color: #333;
  text-decoration: none;
  font-size: 14px;
  transition: background-color 0.2s;
  width: 100%;
  position: relative; /* 위치 정보 계산을 위해 필요 */
}


.nebula-modal-category-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

/* 서브 카테고리 컨테이너에 추가 */
.nebula-modal-subcategory-right {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}


.nebula-modal-subcategory-banner {
  margin-bottom: 20px;
  overflow: hidden; /* 오버플로우 제어 */
  height: auto; /* 높이를 자동으로 조정 */
}

.nebula-modal-subcategory-banner img {
  width: 100%; /* 너비는 100% 유지 */
  height: auto; /* 높이를 자동으로 조정하여 비율 유지 */
  object-fit: contain; /* cover 대신 contain으로 변경하여 이미지 전체 표시 */
  border-radius: 4px;
}

/* 서브 카테고리 리스트에 트랜지션 추가 */
.nebula-modal-subcategory-list {
  display: flex;
  flex-wrap: wrap;
  opacity: 1;
  transition: opacity 0.3s ease;
}

.nebula-modal-subcategory-group {
  width: 100%;
  padding: 0 20px 20px 0;
  transition: opacity 0.3s ease; /* 부드러운 페이드 효과 */
}

.nebula-modal-subcategory-title {
  font-size: 15px;
  font-weight: 600;
  color: #4a6cf7;
  margin: 0 0 15px 0;
  padding-bottom: 5px;
  border-bottom: 1px solid #eee;
}

.nebula-modal-subcategory-items {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.nebula-modal-subcategory-items li {
  margin-bottom: 0;
  margin-right: 15px;
}

.nebula-modal-subcategory-link {
  color: #666;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s;
}

.nebula-modal-subcategory-link:hover {
  color: #4a6cf7;
  text-decoration: underline;
}

/* 반응형 모달 스타일 */
@media (max-width: 992px) {
  .nebula-modal-content {
    width: 95%;
  }

  .nebula-modal-subcategory-group {
    width: 50%;
  }
}

@media (max-width: 768px) {
  .nebula-modal-category-container {
    flex-direction: column;
  }

  .nebula-modal-category-left {
    width: 100%;
    height: auto;
    max-height: 30vh;
    border-right: none;
    border-bottom: 1px solid #eee;
  }

  .nebula-modal-subcategory-right {
    max-height: calc(60vh - 80px);
  }

  .nebula-modal-subcategory-group {
    width: 100%;
  }

  .nebula-modal-content {
    width: 90%;
    max-height: 85vh;
  }

  .nebula-modal-brand-item {
    width: calc(33.33% - 15px);
  }
}

/* 브랜드 모달 스타일 */
.nebula-modal-brand-container {
  display: flex;
  height: 100%;
  max-height: calc(90vh - 80px);
}

.nebula-modal-brand-index {
  width: 120px;
  flex-shrink: 0;
  padding: 15px 0;
  background-color: #f8f8f8;
  border-right: 1px solid #eee;
  overflow-y: auto;
}

.nebula-modal-lang-title {
  display: block;
  padding: 10px 15px;
  color: #333;
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  border-bottom: 1px solid #eee;
}

.nebula-modal-letter-list {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  margin-bottom: 15px;
}

.nebula-modal-letter-link {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  margin: 2px;
  color: #666;
  text-decoration: none;
  border-radius: 4px;
  transition: all 0.2s;
}

.nebula-modal-letter-link:hover {
  background-color: #e9ecef;
  color: #4a6cf7;
}

.nebula-modal-brand-list {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

.nebula-modal-lang-section {
  margin-bottom: 30px;
}

.nebula-modal-lang-header {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.nebula-modal-brand-group {
  margin-bottom: 30px;
}

.nebula-modal-brand-letter {
  font-size: 18px;
  font-weight: 600;
  color: #4a6cf7;
  padding: 5px 10px;
  background-color: #f8f9fa;
  border-radius: 4px;
  margin: 0 0 15px 0;
}

.nebula-modal-brand-items {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.nebula-modal-brand-item {
  width: calc(25% - 15px); /* 20%에서 25%로 변경하여 한 줄에 4개 표시 */
}

.nebula-modal-brand-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  padding: 15px;
  border-radius: 6px;
  transition: all 0.2s;
  border: 1px solid #eee;
}

.nebula-modal-brand-link:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border-color: #ddd;
}

.nebula-modal-brand-logo,
.nebula-modal-brand-placeholder {
  width: 60px; /* 80px에서 60px로 줄임 */
  height: 60px; /* 80px에서 60px로 줄임 */
}

.nebula-modal-brand-name {
  text-align: center;
  color: #333;
  font-size: 14px;
}

/* 반응형 스타일 */
@media (max-width: 992px) {
  .nebula-modal-brand-item {
    width: calc(25% - 15px);
  }
}

@media (max-width: 768px) {
  .nebula-modal-brand-container {
    flex-direction: column;
  }

  .nebula-modal-brand-index {
    width: 100%;
    height: auto;
    max-height: 25vh;
    border-right: none;
    border-bottom: 1px solid #eee;
    padding: 10px 15px;
  }

  .nebula-modal-letter-list {
    margin-bottom: 5px;
  }

  .nebula-modal-brand-item {
    width: calc(33.33% - 15px);
  }
}

@media (max-width: 576px) {
  .nebula-modal-brand-item {
    width: calc(50% - 15px);
  }

  .nebula-modal-brand-logo {
    width: 60px;
    height: 60px;
  }

  .nebula-modal-content {
    width: 95%;
    max-height: 90vh;
  }

  .nebula-modal-brand-item {
    width: calc(50% - 10px); /* 여백 줄이기 */
    margin-bottom: 10px;
  }

  .nebula-modal-brand-logo,
  .nebula-modal-brand-placeholder {
    width: 50px;
    height: 50px;
  }
}

.nebula-modal-brand-placeholder {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f2f2f2;
  color: #666;
  font-size: 24px;
  font-weight: bold;
  border-radius: 4px;
  margin-bottom: 10px;
}

@media (max-width: 576px) {
  .nebula-modal-brand-placeholder {
    width: 60px;
    height: 60px;
    font-size: 20px;
  }
}

/* 모바일 스켈레톤 UI 스타일 추가 */
.mobile-skeleton-menu-btn,
.mobile-skeleton-search-btn {
  display: none;
  width: 24px;
  height: 24px;
  background-color: #e0e0e0;
  border-radius: 4px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.mobile-skeleton-menu-btn {
  left: 15px;
}

.mobile-skeleton-search-btn {
  right: 15px;
}

/* 반응형 스타일에 스켈레톤 UI 관련 미디어 쿼리 추가 */
@media (max-width: 768px) {
  .mobile-skeleton-menu-btn,
  .mobile-skeleton-search-btn {
    display: block;
  }

  .nebula-skeleton-main-header-content {
    justify-content: center;
    padding: 0 50px; /* 좌우 버튼 공간 확보 */
  }

  .nebula-skeleton-main-logo {
    width: 120px;
    height: 40px;
    margin: 0 auto;
  }

  /* 기존 모바일 미디어 쿼리와 동일하게 스켈레톤 UI 조정 */
  .nebula-skeleton-header-content {
    justify-content: flex-end;
  }
}

@media (max-width: 576px) {
  .nebula-skeleton-main-logo {
    width: 100px;
    height: 35px;
  }
}

/* 트랜지션 효과 CSS 추가 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* 로그인/로그아웃 버튼 스타일 */
.auth-buttons {
  display: flex;
  align-items: center;
  margin-left: 15px;
}

.user-name {
  color: #ffffff;
  font-size: 14px;
  margin-right: 10px;
}

.logout-btn, .login-btn, .signup-btn {
  padding: 6px 12px;
  font-size: 13px;
  color: #ffffff;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: none;
  margin-left: 5px;
}

.logout-btn:hover, .login-btn:hover, .signup-btn:hover {
  text-decoration: underline;
}

.signup-btn {
  font-weight: 500;
}

.nebula-modal-subcategory-link.sub-category {
  padding-left: 15px;
  font-size: 13px;
  color: #777;
}
</style>